<template>
  <el-dialog
    title="上传证件"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    z-index="1000"
    append-to-body
    class="dialog"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      label-suffix="："
      size="small"
      label-width="160px"
      style="width: 100%"
    >
      <el-form-item v-if="form.sortName" label="证书分类">
        <span>{{ form.sortName || '-' }}</span>
      </el-form-item>
      <el-form-item label="证件名称">
        <span>{{ form.name || '-' }}</span>
      </el-form-item>
      <el-form-item label="上传附件" prop="fileId">
        <upload
          ref="uploadFile"
          :props-data="{
            uploadMode: 'fileId',
            fileIdBefore: form.fileId,
            acceptFileClassify: ['pdf', 'img'],
            fileSize: 50,
            onSuccess: fileId => (form.fileId = fileId)
          }"
        >
          <div slot="tip" class="tip-mes">
            <p>
              支持pdf、jpg、jpeg、png、bmp、gif，仅能上传单个文件，且大小不超过50M
            </p>
          </div>
        </upload>
      </el-form-item>
      <el-form-item label="证件有效截止日期" prop="expireTime">
        <jczh-date-picker
          v-model="form.expireTime"
          type="datetime"
          :append-to-body="false"
          placeholder="请选择证件有效截止日期"
          :disabled-date="disabledDate"
          :disabled-time="disabledTime"
          default-time="23:59:59"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="medium-button" size="small" @click="closeDialog">
        取消
      </el-button>
      <el-button
        type="primary"
        class="medium-button"
        size="small"
        @click="submit"
      >
        确认
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/common/Upload'
export default {
  components: {
    Upload
  },

  data() {
    return {
      dialogVisible: false,
      uploading: false, // 文件上传标志
      submitApi: '', //  确认提交触发api请求，为''则无请求
      form: {
        fileId: '',
        expireTime: ''
      },
      formRules: {
        expireTime: [
          {
            required: true,
            message: '请选择证件有效截止日期',
            trigger: ['blur', 'change']
          }
        ],
        fileId: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: '请上传附件',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open(data, api = '') {
      this.dialogVisible = true
      this.form = { ...this.form, ...data }
      this.submitApi = api
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.$refs.form.clearValidate()
      this.form = {
        fileId: '',
        expireTime: ''
      }
      this.dialogVisible = false
    },

    /**
     * 确认提交文件
     */
    submit() {
      this.$refs.form.validate(async valid => {
        if (this.$refs.uploadFile && !this.$refs.uploadFile.uploadComplete()) {
          return false
        }
        const submitData = {
          certificateCategoryId: this.form.id,
          fileId: this.form.fileId,
          expireTime: this.form.expireTime
        }
        // 没有submitApi，直接关闭返回列表数据
        if (!this.submitApi) {
          this.$emit('refresh', submitData)
          this.closeDialog()
          return
        }

        if (valid) {
          try {
            await this.$confirm(`确定是否上传证件`, '系统提示', {
              type: 'warning'
            })
            await this.submitApi(submitData)
            this.$emit('refresh', submitData)
            this.closeDialog()
          } catch (err) {
            err.message && this.$message.error(err.message)
          }
        }
      })
    },

    /**
     * 有效时间
     */
    disabledDate(date) {
      // 不能早于今天
      return date < new Date().setHours(0, 0, 0, 0)
    },

    /**
     * 有效时间
     */
    disabledTime(date) {
      // 不能早于今天的当前时刻
      return date.getTime() < new Date().getTime()
    }
  }
}
</script>
<style lang="scss" scoped>
.tip-mes {
  color: $third-text-color;
  padding-left: pixel-to-rem($n: 20);
  p {
    font-size: pixel-to-rem($n: 16);
    margin: 0;
  }
}
</style>
